import React, { useMemo } from 'react'
import BigNumber from 'bignumber.js'
import { Box, Group, Space, Title, useMantineTheme } from '@mantine/core'
import { convertMicroDenomToDenom } from '@/atoms/Wallet'
import { STRIDE_CURRENCY } from '@/config'
import { useClaimHistoryQuery, useRebateProgramQuery } from '../queries'
import { AirdropClaimRow } from './AirdropClaimRow'

const AirdropClaimHistory = () => {
  const theme = useMantineTheme()

  const { data: claimHistory } = useClaimHistoryQuery()

  const { data: rebateProgram } = useRebateProgramQuery()

  const records = useMemo(() => {
    return claimHistory?.records ?? []
  }, [claimHistory?.records])

  const claimedRebateAmount = useMemo(() => {
    if (rebateProgram == null) {
      return 0
    }

    if (['ineligible', 'unclaimed'].includes(rebateProgram.status)) {
      return 0
    }

    return rebateProgram.amount
  }, [rebateProgram])

  const totalClaimedDenom = useMemo(() => {
    const totalClaimable = records.reduce((total, record) => {
      return total.plus(record.total)
    }, new BigNumber(0))

    const totalWithRebateAmount = totalClaimable.plus(claimedRebateAmount)

    return new BigNumber(convertMicroDenomToDenom(totalWithRebateAmount)).decimalPlaces(2).toString()
  }, [records, claimedRebateAmount])

  if (!records.length && !claimedRebateAmount) {
    return null
  }

  return (
    <>
      <Group position="apart">
        <Title order={5}>Claim history</Title>

        <Title order={5} sx={{ fontWeight: 400 }}>
          Total claimed:{' '}
          <strong>
            {totalClaimedDenom} {STRIDE_CURRENCY.coinDenom}
          </strong>
        </Title>
      </Group>

      {Boolean(records.length) && (
        <>
          <Space h="md" />

          <Box pl={theme.spacing.md - theme.spacing.xs - theme.other.airdropClaim.newEntrySize} pr="md">
            {records.map((record, i) => {
              return <AirdropClaimRow record={record} key={i} />
            })}
          </Box>
        </>
      )}
    </>
  )
}

export { AirdropClaimHistory }
